var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('card-navigation-skeleton',{staticStyle:{"margin-bottom":"20px"}}),_c('card-navigation-skeleton',{staticStyle:{"margin-bottom":"20px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }